export default __webpack_public_path__ + "static/media/clock_poster.9ecbc2b2.svg";